export class PreferredPronounsLang {
    public He: string;
    public She: string;
    public They: string;
    public Other: string;
}


// WEBPACK FOOTER //
// ./src/resources/PreferredPronounsLang.ts